import { Link } from "react-router-dom";

const Overlay = () => {
  return (
    <div className="overlay">
      <h1 className="heading">
        You do not have the privilege to access this page!
      </h1>
      <Link to="/">
        <button className="btn overlay-btn">Go back to Dashboard</button>
      </Link>
    </div>
  );
};

export default Overlay;
